<template>
    <div class="row g-3">
      <!-- Indicateur de chargement -->
      <div v-if="loading" class="col-12 text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
      </div>
  
      <!-- Message d'erreur -->
      <div v-if="error" class="col-12">
        <div class="alert alert-danger">
          {{ error }}
        </div>
      </div>
  
      <!-- Cartes de statistiques -->
      <div v-if="!loading && !error" class="col-xl-3 col-md-6 mb-4">
          <div class="dashboard-card accent-warning shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-warning text-uppercase mb-1">
                  Actions en retard
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800 stat-value">{{ totalActionsEnRetard }}</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-hourglass-start fa-2x text-warning"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div v-if="!loading && !error" class="col-xl-3 col-md-6 mb-4">
        <div class="dashboard-card accent-info shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-info text-uppercase mb-1">
                  Recommandations à ce jour
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800 stat-value">{{ totalRecommendations }}</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-calendar fa-2x text-info"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div v-if="!loading && !error" class="col-xl-3 col-md-6 mb-4">
        <div class="dashboard-card accent-primary shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">
                  Actions en cours
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800 stat-value">{{ totalActionsEnCours }}</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-clock fa-2x text-primary"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div v-if="!loading && !error" class="col-xl-3 col-md-6 mb-4">
        <div class="dashboard-card accent-success shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                  Actions terminées
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800 stat-value">{{ totalActionsTerminees }}</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-check-circle fa-2x text-success"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
import axios from 'axios';
import { safeErrorMessage } from '@/utils/errorMessages';
import "@/assets/css/stats.css";
import { isAuthenticatedSession } from '@/utils/sessionAuth';
  
  export default {
    name: "CardStat",
    data() {
      return {
        recommendations: [],
        statistiquesGlobales: null,
        count: 0,
        loading: false,
        error: null
      };
    },
    computed:{
    totalRecommendations() {
      if (this.statistiquesGlobales) {
        return this.statistiquesGlobales.total_recommandations || this.count || 0;
      }
      return this.count || this.recommendations.length;
    },
    totalActionsEnCours() {
      if (this.statistiquesGlobales) {
        return this.statistiquesGlobales.recommandations_en_cours || 0;
      }
      return this.recommendations.filter((r) => r.statut === 'en_cours').length;
    },
    totalActionsEnRetard() {
      if (this.statistiquesGlobales) {
        return this.statistiquesGlobales.recommandations_en_retard || 0;
      }
      return this.recommendations.filter((r) => r.est_en_retard).length;
    },
    totalActionsTerminees() {
      if (this.statistiquesGlobales) {
        return this.statistiquesGlobales.recommandations_terminees || 0;
      }
      return this.recommendations.filter((r) => r.statut === 'terminee').length;
    },
    },
    methods: {
      async fetchRecommendations() {
      this.loading = true;
      this.error = null;
      
      try { 
        if (!isAuthenticatedSession()) {
          this.error = "Token non trouvé, veuillez vous connecter.";
          this.$router.push('/connexion');
          return;
        }

        const response = await axios.get("/api/raci/", {
          withCredentials: true
        });

        this.recommendations = response.data.recommandations || [];
        this.statistiquesGlobales = response.data.statistiques_globales || null;
        this.count = typeof response.data.statistiques_globales?.total_recommandations === 'number'
          ? response.data.statistiques_globales.total_recommandations
          : (typeof response.data.count === 'number' ? response.data.count : this.recommendations.length);
      } catch (error) {
        console.error('Erreur:', error);
        if (error.response?.status === 401) {
          this.$router.push('/connexion');
        } else {
          this.error = safeErrorMessage(error, "Une erreur est survenue lors de la récupération des recommandations.");
        }
      } finally {
        this.loading = false;
      }
    },
    },
    mounted() {
      this.fetchRecommendations(); // Décommenté pour charger les données au montage du composant
    }
  };
  </script>
  
  <style scoped>
  </style>
